import { STRIPE_PRICE_IDS } from '../lib/stripe';

export interface CreateSubscriptionParams {
  priceId: string;
  customerEmail: string;
  customerName: string;
  creatorId: string;
  userId: string;
  paymentMethodId?: string;
}

export interface PaymentError {
  type: 'card_error' | 'validation_error' | 'api_error';
  message: string;
  code?: string;
}

export class StripeService {
  // Create a subscription using the backend API
  static async createSubscription(params: CreateSubscriptionParams) {
    try {
      const response = await fetch('http://localhost:3001/api/create-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        let errorMessage = 'Failed to create subscription';
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        } catch (parseError) {
          // If we can't parse the error response, use the status text
          errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      const result = await response.json();
      
      // Validate that we have the required fields
      if (!result.client_secret) {
        throw new Error('Invalid response from server: missing client_secret');
      }
      
      return result;
    } catch (error) {
      console.error('Error creating subscription:', error);
      throw error;
    }
  }

  // Get price details from Stripe (we'll implement this when we have the backend)
  static async getPriceDetails(priceId: string) {
    try {
      const response = await fetch(`http://localhost:3001/api/price-details/${priceId}`);
      
      if (!response.ok) {
        throw new Error('Failed to get price details');
      }

      return await response.json();
    } catch (error) {
      console.error('Error getting price details:', error);
      throw error;
    }
  }

  // Get available plans with pricing
  static getAvailablePlans() {
    return {
      monthly: {
        id: STRIPE_PRICE_IDS.monthly,
        name: 'Monthly subscription',
        price: 10,
        interval: 'month',
        displayPrice: '$10',
        displayInterval: '/month'
      },
      yearly: {
        id: STRIPE_PRICE_IDS.yearly,
        name: 'Yearly subscription',
        price: 99,
        interval: 'year',
        displayPrice: '$99',
        displayInterval: '/year',
        originalPrice: 120
      }
    };
  }
} 